import { makeEntityScaffold } from '@classpass/saga-tools';

import URLS from 'constants/urls';
import { transformV2ClientResponse } from 'helpers/core';

const handler = ({ httpClient }) => {
  const endpoint = URLS.calendarConfigurationPlatforms();

  return httpClient.get(endpoint).then(transformV2ClientResponse);
};

export default makeEntityScaffold('SAGA.API.CALENDAR_CONFIGURATION_PLATFORMS', handler);
